import SearchIcon from '@mui/icons-material/Search';
import { MenuItem, TextField } from '@mui/material';
import Grid from '@mui/material/Grid';
import { useEffect, useState } from 'react';
import { convertToMexicoTime } from 'utils/helpers/convertToMexicoTime';
import GenericAddButton from 'widgets/GenericAddButton/GenericAddButton';

const FiltroListVinculation = ({
  handleSubmit,
  onSubmit,
  register,
  errors,
  statusOptions = [],
  flowsOptions = [],
  typeOptions = [],
}) => {
  const [currentDate, setCurrentDate] = useState('');

  useEffect(() => {
    const today = new Date().toISOString();
    const todayMexico = convertToMexicoTime(today);
    setCurrentDate(todayMexico.split(' ')[0]);
  }, []);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={1} alignItems='flex-start'>
        <Grid item size={{ xs: 12, xl: 1 }}>
          <TextField
            fullWidth
            label='Desde'
            type='date'
            {...register('from_date')}
            InputLabelProps={{
              shrink: true,
            }}
            error={Boolean(errors.from_date)}
            helperText={errors.from_date?.message}
            slotProps={{
              htmlInput: {
                max: currentDate,
              },
            }}
          />
        </Grid>
        <Grid item size={{ xs: 12, xl: 1 }}>
          <TextField
            fullWidth
            label='Hasta'
            type='date'
            {...register('to_date')}
            InputLabelProps={{
              shrink: true,
            }}
            error={Boolean(errors.to_date)}
            helperText={errors.to_date?.message}
            slotProps={{
              htmlInput: {
                max: currentDate,
              },
            }}
          />
        </Grid>

        <Grid item size={{ xs: 12, xl: 2 }}>
          <TextField
            fullWidth
            label='Referencia interna'
            {...register('internal_reference', {
              pattern: {
                value: /^\d+$/,
                message: 'Solo se permiten números',
              },
            })}
            error={Boolean(errors.internal_reference)}
            helperText={errors.internal_reference?.message}
          />
        </Grid>

        <Grid item size={{ xs: 12, xl: 1 }}>
          <TextField
            select
            fullWidth
            label='Flujo'
            defaultValue=''
            {...register('linked_up_flow_id')}
            error={Boolean(errors?.linked_up_flow_id)}
            helperText={errors?.linked_up_flow_id?.message}
          >
            <MenuItem value=''>
              <em>-- Seleccionar --</em>
            </MenuItem>
            {(flowsOptions || []).map((option) => (
              <MenuItem key={option.id} value={option.id}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid item size={{ xs: 12, xl: 1 }}>
          <TextField
            select
            fullWidth
            label='Status'
            defaultValue=''
            {...register('linked_up_status_id')}
            error={Boolean(errors?.linked_up_status_id)}
            helperText={errors?.linked_up_status_id?.message}
          >
            <MenuItem value=''>
              <em>-- Seleccionar --</em>
            </MenuItem>
            {statusOptions.map((option) => (
              <MenuItem key={option.id} value={option.id}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid item size={{ xs: 12, xl: 1 }}>
          <TextField
            select
            fullWidth
            label='Tipo'
            defaultValue=''
            {...register('linked_up_type')}
            error={Boolean(errors?.linked_up_type)}
            helperText={errors?.linked_up_type?.message}
          >
            <MenuItem value=''>
              <em>-- Seleccionar --</em>
            </MenuItem>
            {typeOptions.map((option) => (
              <MenuItem key={option.id} value={option.id}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid item size={{ xs: 12, xl: 1 }} padding={{ xl: 1 }}>
          <GenericAddButton
            buttonText='Buscar'
            backgroundColor='#4C2484'
            size='medium'
            isSubmit
            icon={<SearchIcon />}
          />
        </Grid>
      </Grid>
    </form>
  );
};

export default FiltroListVinculation;
